module.exports = __webpack_public_path__ + "static/media/photography-inclusive.0d1f6edd.svg";